import { useApi } from '../lib/api'

// Validation page — confirms the whole stack works end-to-end:
//   ✓ React Router renders
//   ✓ Sidebar + header from AppShell match vanilla aesthetic
//   ✓ Firebase auth flows through useAuth
//   ✓ useApi calls /api/* with bearer token and tenant header
//   ✓ Shared CSS classes (.summary-card-9fig etc.) work via copied stylesheet
// Once these all pass, this page can be deleted.
interface AuthMe { email: string; tenant_id: string | null; is_super_admin: boolean }

export function Hello() {
  const { data, isLoading, error } = useApi<AuthMe>('/api/auth/me')

  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '24px 0' }}>
      <div className="eyebrow">app-react · validation</div>
      <h1 style={{ fontFamily: 'var(--font-display, Plus Jakarta Sans)', fontSize: 28, fontWeight: 800, marginBottom: 4 }}>
        React port: stack check
      </h1>
      <p style={{ color: 'var(--text-muted)', marginBottom: 24 }}>
        If you see your email below and the sidebar + header look identical to vanilla, the foundation is working.
      </p>

      <div className="summary-card-9fig" style={{ padding: 20 }}>
        <div className="card-label">/api/auth/me round-trip</div>
        {isLoading && <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>Loading…</div>}
        {error && (
          <div style={{ color: 'var(--danger)', fontSize: 13 }}>
            Error: {(error as Error).message}
          </div>
        )}
        {data && (
          <pre style={{ background: 'var(--bg-element)', padding: 12, borderRadius: 6, fontSize: 12, overflow: 'auto', margin: '12px 0 0' }}>
            {JSON.stringify(data, null, 2)}
          </pre>
        )}
      </div>
    </div>
  )
}
